/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,
    ClipPath,
    Use,
    Defs,
    Stop
} from 'react-native-svg';

            export const SvgShipping= ({size}) => {
    return (  <Svg width={size} height={size} viewBox="0 0 81.93 82.42">
          
                <ClipPath id="clip-path">
                    <Circle class="cls-1" fill = "none" cx="41" cy="41" r="40" />
                </ClipPath>
                <ClipPath id="clip-path-2">
                    <Rect class="cls-1"  fill = "none" width="82" height="82" />
                </ClipPath>
                <ClipPath id="clip-path-3">
                    <Path class="cls-2"  fill = "none" clipRule= "evenodd" d="M43.11,47.41a2.94,2.94,0,0,1-4.23,0L34,42.35,23.46,53.14H58.54L48,42.36Zm6.62-6.79,9.77,10v-20ZM22.5,30.2V50.64l9.79-10C27.1,35.23,24.15,32.1,22.5,30.2ZM41.41,45.66,57.8,28.86H24.57c2.78,3.06,8.6,9.18,16,16.81A.59.59,0,0,0,41.41,45.66Z" />
                </ClipPath>
         
            <G  clipPath = "url(#clip-path)" class="cls-3">
                <G 
                clipPath = "url(#clip-path-2)"
                class="cls-4">
                    <Rect class="cls-5" fill = "#4a536c" x="-4" y="-4" width="90" height="90" />
                </G>
            </G>
            <G 
            clipPath ="url(#clip-path-3)"
            class="cls-6">
                <G class="cls-4">
                    <Rect class="cls-7" fill = "#fff" x="17.5" y="23.86" width="47" height="34.28" />
                </G>
            </G>
        </Svg>)
        }
        
